import { AdobeMedia } from '../types';

type ExtendedMediaObject = {
  'media.name': string;
  'media.id': string;
  'media.length': number;
  'media.streamType': string;
};
export function createMediaObject(
  title: string,
  mediaId: string,
  length: number,
  contentType: string,
  streamType: string
): ReturnType<AdobeMedia['createMediaObject']> & ExtendedMediaObject {
  return {
    'media.name': title,
    'media.id': mediaId,
    'media.length': length,
    'media.contentType': contentType,
    'media.streamType': streamType,
  };
}
